<template>
  <ServicePageLayout
    title="Air Quality"
    subtitle="ระบบติดตามคุณภาพอากาศ"
    icon="mdi-air-filter"
    icon-color="success"
    breadcrumb="Operations"
  >
    <v-tabs v-model="tab" class="industrial-tabs">
      <v-tab>Dashboard</v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item>
        <v-card flat class="service-content-panel">
          <v-card-text><Dashboard /></v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </ServicePageLayout>
</template>

<script>
import ServicePageLayout from '@/components/layout/ServicePageLayout.vue'
import Dashboard from '@/components/air_quality/air_quality_dashboard'

export default {
  name: 'AirQualityView',
  components: {
    ServicePageLayout,
    Dashboard,
  },
  data() {
    return { tab: null }
  },
}
</script>
